var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-columns",
    {
      scopedSlots: _vm._u([
        {
          key: "rightColumn",
          fn: function() {
            return [_c("live-data")]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-tabs",
        { staticClass: "va-card pa-0 mb-6" },
        [
          _c("v-tab", { attrs: { to: "/analytics/health" } }, [
            _vm._v("health")
          ]),
          _c("v-tab", { attrs: { to: "/analytics/quality" } }, [
            _vm._v("quality")
          ]),
          _c("v-tab", { attrs: { to: "/analytics/usage" } }, [_vm._v("usage")]),
          _c("v-tab", { attrs: { to: "/analytics/green" } }, [_vm._v("green")]),
          _c("v-tab", { attrs: { to: "/analytics/efficency" } }, [
            _vm._v("efficency")
          ])
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }